import { Box } from "@mui/material";

function IconComponent(props) {
    const iconName = props.icon || props.name;

    return(
        <Box
            component="span"
            className="material-symbols-outlined"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: props.size,
            }}
        >
            {iconName}
        </Box>
    );
}

export default IconComponent;
